import ssoImg1 from "./../../../../assets/images/Services.jpg"; // Adjust the path as necessary


function ShipRepairMaintenance() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        MOSR{" "}
        <span className="text-orange-ef3e33 font-400"> Ship repair and maintenance </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-4 g-lg-5">
        {/* <div className="col-lg-5">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> */}
        <div className="col-lg">
          <div className="">
            {/* <p className="mb-4 font-18 font-900">
           ​​​Boating - Safety Surveys
          </p> */}

          {/* <p className="mb-4">
            What is stevedoring: Stevedoring is the process of loading and unloading cargo onto and from ships at ports. Stevedores handle various types of cargo, including containers, bulk materials, and heavy equipment (project cargo). The industry has seen various changes over the years with one of the major changes being containerisation which began in the 1950s and reached South Africa in the 1970s. Prior to containerisation cargo was being transported by bulk cargo vessels and manually picked from cargo holds onto the quayside. This involved a large number of stevedores with the numbers reaching 100s. Containerisation brought about changes which included job losses as cargo was now lifted by a crane from the cargo hold or deck onto the quayside. The risk profile of stevedoring also changed as now operations involved suspended loads. Stevedoring is regarded as one of the dangerous occupations as it involves a lot of moving parts and suspended loads.
          </p> */}

          </div><div className="col-lg">
          <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
        </div> <br />
        <p className="mb-4">
          South Africa has a well-established ship repair and maintenance industry which offers quality service to the visiting ships. In addition to ships calling regularly into South African ports. South African ship repair and maintenance industry is also able to take advantage of the countries geographical location which sits on one of the world’s main shipping lanes. Ship repair and maintenance jobs is almost similar to a construction site with added peculiar hazards and risks presented by different ships types.
        </p>
        {/* <p className="mb-4 font-18 font-900">
           MOSR compliance regime
          </p>
          <p className="mb-4">
            Management of the compliance regime for stevedoring operations falls within SAMSA’s OHS & Maritime Welfare Unit. The Unit comprise of specialists in the field of Occupational Health and Safety. The Unit execute its mandate through the following activities.
          </p> */}
          <div className="accordion blackTab" id="blackTab">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabOne"
                  aria-expanded="false"
                  aria-controls="blackTabOne"
                >Ship repair and maintenance MOSR safety    
                </button>
              </h2>
              <div
                id="blackTabOne"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                    Ship repair and maintenance MOSR safety inspections are conducted nationally in all the ports and applicable harbours. These are announced inspections involving observation of ship repair and maintenance operations for unsafe acts and conditions, inspection of personal protective equipment, as well as inspection of machinery and access equipment. The inspection also involves inspection of safety documentations i.e. daily occupational safety inspection checklist, toolbox talk, induction register, permit to work system etc
                    </p>
                  </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button "
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabTwo"
                  aria-expanded="true"
                  aria-controls="blackTabTwo"
                >Ship repair and maintenance safety company audits   
                </button>
              </h2>
              <div
                id="blackTabTwo"
                className="accordion-collapse collapse show"                
                data-bs-parent="#blackTab"
              >
                <div className="accordion-body">
                  <p className="mb-3">
                  Ship repair and maintenance company audits are audited biennially. The audit takes place at the company’s premises and companies are audited only for work on board vessels. The audit involves safety management documentation review i.e. baseline risk assessment, induction programme, safe working procedures etc, including auditing of machinery, lifting gear that is used in ship repair and maintenance operations.
                  </p>
                  </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTabThree"
                  aria-expanded="false"
                  aria-controls="blackTabThree"
                >Ship repair and maintenance safety committee meetings 
                </button>
              </h2>
              <div
                id="blackTabThree"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                  <p className="mb-3">
                   Ship repair and maintenance safety committee meetings are held biennially. During, the meetings companies are able to sit down together and discuss safety related issues including incidents and compliance challenges. During the meetings SAMSA shares casualty statistics and safety observations from the inspections around the country as well as common audit findings. The meetings are attended by all ship repair and maintenance companies in a particular port, Transnet National Port Authority (TNPA), Transnet Port Terminals (TPT) and from time other relevant entities are invited to present at the meetings.  The ship repair and maintenance committee meetings have been established in these ports:
                    </p>
                    <p className="mb-3">i. Durban
                    </p>
                    <p className="mb-3">ii. Cape Town
                    </p>         
                </div>
               </div>
             </div>   
             <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTab4"
                  aria-expanded="false"
                  aria-controls="blackTab4"
                >Awareness campaigns (why, how, photos)
                </button>
              </h2>
              <div
                id="blackTab4"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                  <p className="mb-3">
                    SAMSA conducts awareness campaigns at company premises by invitation. Awareness campaigns can also be targeted i.e. new companies, companies with challenges when it comes to compliance or experiences high number of casualties. The awareness campaigns involve awareness of the MOSR as well as its application including practical application. SAMSA has produced a Ship repair and maintenance safety video to provide awareness on MOSR compliance requirements as well as provide a broad awareness of hazards and risks associated with stevedoring. The videos main target were the smaller companies which did not have the resources to produce comprehensive induction resources. The videos are produced in English, isiZulu, IsiXhosa and Afrikaans. The video can be utilised by stevedore companies for induction training. The stevedore video is broad as such each company is to use it to supplement its own induction programme which will cover items specific to their operations.
                  </p>
                             
                </div>
               </div>
             </div>
             <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#blackTab5"
                  aria-expanded="false"
                  aria-controls="blackTab5"
                >Casualty investigations (statistics)
                </button>
              </h2>
              <div
                id="blackTab5"
                className="accordion-collapse collapse"
                data-bs-parent="#blackTab">
                <div className="accordion-body">
                  
                    <p className="mb-3">SAMSA conducts casualty investigations for incidents involving stevedores. The main purpose of the investigations is to establish the root cause of the incidents and to prevent future occurrences.  Casualties occurring onboard a ship are reported to SAMSA using official forms obtainable from SAMSA local offices and this website under the Forms section.
                    </p>         
                </div>
               </div>
             </div>
              <p className="mb-4">
              If you operate in the ship repair and maintenance industry and wants to be part of the safety/stakeholders committee meetings, kindly contact SAMSA via the SAMSA contact from or email <a href="mailto:nmjweni@samsa.org.za">nmjweni@samsa.org.za</a>
             </p>   
             <p className="mb-4">To report any ship repair and maintenance safety related concerns, kindly communicate with SAMSA via the SAMSA contact form or email <a href="mailto:nmjweni@samsa.org.za">nmjweni@samsa.org.za</a>  or  contact the local SAMSA Office ( The office contact details are provided in this website).
             </p>


          </div>
        </div>      
        
      </div>
    </>
  );
}


export default ShipRepairMaintenance